import React, { useContext, useEffect, useState, useRef } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { validateEmail, valPnBoCc } from '../../../lib/validation';
import InputField from "../../../lib/ui/inputs/Input";
import Button from "../../../lib/ui/buttons/Button";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import ReactQuillEditor from "../../../components/reactQuillEditor";
import { createTerms, getTerms, updateTerms } from "../../../actions/configuration";
import Loader from "../../../lib/ui/loader/Loader";
import { toast } from "react-toastify";
import "react-phone-number-input/style.css";
import { validateExtraAlphaNumSpecial } from "../../../lib/validation";

const Branding = () => {
    const quillRef = useRef(null);
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);
    const [error, setError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);
    const [edit, setEdit] = useState(true);
    const [loading, setLoading] = useState(false);

    const [termsCond, setTermsCond] = useState({
        id: "",
        email: "",
        brandName: "",
        terms: "",
        phone: "",
        // concern: "",
    });
    const [prevTermsCond, setPrevTermsCond] = useState({
        id: "",
        email: "",
        brandName: "",
        terms: "",
        phone: "",
        // concern: "",
    });

    const handleChange = (e) => {
        setTermsCond({ ...termsCond, [e.target.name]: e.target.value });
        setError({...error, [e.target.name]: ""})
    };

    const handleGet = () => {
        setLoading(true);
        let query = `?subdomain=${payload?.subdomain}`;
        getTerms(query)
            .then((res) => {
                if (res?.status && res?.data) {
                    setTermsCond({
                        id: res?.data?._id,
                        email: res?.data?.email,
                        brandName: res?.data?.brandName,
                        terms: res?.data?.terms ? decodeURIComponent(res?.data?.terms) : "",
                        phone: res?.data?.phone,
                        // concern: res?.data?.concern ? decodeURIComponent(res?.data?.concern) : "",
                    });
                    setPrevTermsCond({
                        id: res?.data?._id,
                        email: res?.data?.email,
                        brandName: res?.data?.brandName,
                        terms: res?.data?.terms ? decodeURIComponent(res?.data?.terms) : "",
                        phone: res?.data?.phone,
                        // concern: res?.data?.concern ? decodeURIComponent(res?.data?.concern) : "",
                    });
                    let concern = res?.data?.concern || "" // ? decodeURIComponent(res?.data?.concern) : "";
                    quillRef.current = concern
                    setEdit(true);
                }
                setLoading(false);
            })
            .catch((e) => {
                console.error("Error fetching terms:", e);
                setLoading(false);
            });
    };

    useEffect(() => {
        handleGet();
    }, []);

    const validateForm = () => {
        let _error = {};
        let returnValue = true;
        if (termsCond.brandName === '' || termsCond.brandName === null) {
            _error['brandName'] = l.pls_enter_brand;
            returnValue = false;
        } else if (!validateExtraAlphaNumSpecial(termsCond.brandName)) {
            _error['brandName'] = l.pls_check_brand;
            returnValue = false;
        }
        if (termsCond.email === '' || termsCond.email === null) {
            _error['email'] = l.pls_enter_email;
            returnValue = false;
        }
        else if (!validateEmail(termsCond.email)) {
            _error['email'] = l.pls_check_email;
            returnValue = false;
        }
        if (termsCond.phone === '' || termsCond.phone === null) {
            _error['phone'] = l.pls_enter_phone;
            returnValue = false;
        }
        else if (!isValidPhoneNumber(termsCond.phone)) {
            _error['phone'] = l.pls_check_phone;
            returnValue = false;
        } else if (!valPnBoCc(termsCond.phone)) {
            _error['phone'] = l.pls_check_phone;
            returnValue = false;
        }
        setError(_error);
        return returnValue;
    }

    const handleSubmitData = async () => {
        setLoading(true);
        if (validateForm()) {
            let body = {
                brandName: termsCond.brandName,
                email: termsCond.email,
                phone: termsCond.phone,
                terms: termsCond.terms,
                clinicId: payload.userId,
                concern: quillRef.current,
            };

            if (termsCond?.id === "") {
                body["subdomain"] = payload.subdomain;

                createTerms(body)
                    .then((res) => {
                        setPrevTermsCond(termsCond)
                        setEdit(true);
                        setLoading(false);
                        toast.success("Terms Created Successfully", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    })
                    .catch((err) => {
                        console.error("Error creating terms:", err);
                        setLoading(false);
                        toast.error(err.response?.data?.error);
                    });
            } else {
                body["id"] = termsCond.id;

                updateTerms(body)
                    .then((res) => {
                        setPrevTermsCond(termsCond)
                        setEdit(true);
                        setLoading(false);
                        toast.success("Terms Updated Successfully", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    })
                    .catch((err) => {
                        console.error("Error updating terms:", err);
                        setLoading(false);
                        toast.error(err.response?.data?.error);
                    });
            }
        } else {
            setLoading(false)
        }
        
        // else {
        //     if (errorMsg != null) {
        //         window.scrollTo({
        //             top: 0,
        //             behavior: "smooth"
        //         });
        //     }
        // }
    };

    const handlePhone = (value) => {
        setTermsCond({ ...termsCond, phone: value });
        setError({...error, phone: "" })
    };

    const handleTerms = (value) => {
        setTermsCond({ ...termsCond, terms: value });
    };

    const handleConcern = (value) => {
        quillRef.current = value;
    };

    const handleCancel = () => {
        setEdit(true);
        setTermsCond(prevTermsCond)
        setError(null)
    };

    return (
        loading ? ( <Loader/> 
        ):(
        <>
            <div className="formCol pos-rel">
                <div className="formListGroup">
                    {!loading && (
                        <div className="flexCol">
                            <div className="flexCol whiteBg brdrRadius pdngMD margV12px">
                                <div className="pdngBSM brdrBtm">
                                    <small className="inpLabelSection">{l.branding_name}</small>
                                </div>
                                <div className={`inputRowFeild ${edit ? "disabledStripeInput" : ""}`}>
                                    <InputField
                                        readOnly={edit}
                                        placeholder="Brand Name"
                                        name="brandName"
                                        type="text"
                                        value={termsCond.brandName}
                                        error={error && error?.brandName}
                                        errorMsg={error?.brandName}
                                        onChange={handleChange}
                                        maxLength="50"
                                    />
                                </div>
                            </div>
                            <div className="flexCol whiteBg brdrRadius pdngMD margV12px">
                                <div className="pdngBSM brdrBtm">
                                    <small className="inpLabelSection">{l.brand_terms_cndtn}</small>
                                </div>
                                <ReactQuillEditor
                                    placeholder="Terms & Conditions"
                                    readOnly={edit}  
                                    name="terms"
                                    textData={termsCond.terms}
                                    setTextData={handleTerms}
                                />
                            </div>
                            <div className="flexCol whiteBg brdrRadius pdngMD margV12px">
                                <div className="pdngBSM brdrBtm">
                                    <small className="inpLabelSection">{l.branding_concern}</small>
                                </div>
                                <div className="flexCol pdngTSM">
                                    {/* <InputField
                                    placeholder="Patient Concern"
                                    type="text"
                                    name="Patient Concern"
                                    value={termsCond.concern}
                                    onChange={(e) => setTermsCond({ ...termsCond, concern: e.target.value })}
                                /> */}
                                    <ReactQuillEditor
                                        ref={quillRef}
                                        placeholder="Patient Concern"
                                        readOnly={edit}
                                        name="terms"
                                        textData={quillRef.current}
                                        setTextData={handleConcern}
                                    />
                                </div>
                            </div>
                            <div className="flexCol whiteBg brdrRadius pdngMD margV12px">
                                <div className="pdngBSM brdrBtm">
                                    <small className="inpLabelSection">{l.branding_support}</small>
                                </div>
                                <small className="inpLabel">{l.edit_phone_no}</small>
                                <div className="inputBox colBlock nopdng">  
                                    <PhoneInput
                                        readOnly={edit}
                                        className={`customPkgInput nopdng ${edit ? "PhoneInput--readOnly" : ""} ${phoneError ? "error" : ""}`}
                                        international
                                        countryCallingCodeEditable={false}
                                        defaultCountry="IN"
                                        maxLength="17"
                                        value={termsCond.phone}
                                        onChange={handlePhone}
                                    />  
                                    {(error && error.phone) && <span className="inputErrorMsg">{error.phone}</span>}
                                </div>
                                <small className="inpLabel">{l.email_address}</small>
                                <div className={`inputRowFeild ${edit ? "disabledStripeInput" : ""}`}>
                                    <InputField
                                        readOnly={edit}
                                        placeholder={l.email_address}
                                        type="email"
                                        maxLength="100"
                                        name="email"
                                        value={termsCond.email}
                                        error={error && error?.email}
                                        errorMsg={error?.email}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            <div className="crdBtnContainer">
                                {edit ? (
                                    <div className="rowBlock justfiyEnd">
                                        <Button label={l.edit} type="outLine" onClick={() => setEdit(false)} size="md" />
                                    </div>
                                ) : (
                                    <div className="rowBlock justfiyEnd">
                                        <Button
                                            label={l.cancel}
                                            onClick={handleCancel}
                                            type="outLine"
                                            size="md"
                                        />
                                        <Button buttonType="submit" onClick={handleSubmitData} label={l.save} type="primary" size="md" />
                                    </div>
                                )}
                                

                                {/* </div> */}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
        )  
    );
};

export default Branding;
